import { render, staticRenderFns } from "./ActiveMasterProposals.vue?vue&type=template&id=78e355f4&scoped=true&"
import script from "./ActiveMasterProposals.vue?vue&type=script&lang=js&"
export * from "./ActiveMasterProposals.vue?vue&type=script&lang=js&"
import style0 from "./ActiveMasterProposals.vue?vue&type=style&index=0&id=78e355f4&prod&lang=css&"
import style1 from "./ActiveMasterProposals.vue?vue&type=style&index=1&id=78e355f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e355f4",
  null
  
)

export default component.exports